import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import ModalCustom from '../../UI/modal';
import ThInputText from '../../forms/th-input-text';
import Button from '../../UI/button';
import { IPlacesModel, useAddActivity } from './use-add-activity';
import { ISearchBiasModel } from '../../../Models/search-bias.model';
import { useTrip } from '../../contexts/trip-context';
import ActivityAutocomplete from '../../activity-autocomplete';

type Props = {
  show: boolean;
  handleClose: () => void;
  place?: IPlacesModel;
  bias?: ISearchBiasModel;
  parentFolderId?: string;
  tripId?: string;
};

const AddActivityModal = ({
  show,
  handleClose,
  parentFolderId: propParentFolderId,
  tripId: propTripId,
  place,
  bias
}: Props) => {
  const { trip, activeFolderIds } = useTrip();

  // Use context mode if props are not provided
  const tripId = propTripId || trip?.id || '';
  const parentFolderId =
    propParentFolderId ||
    (activeFolderIds && activeFolderIds.length > 0 ? activeFolderIds[0] : '') ||
    '';

  const {
    activity,
    validated,
    isSubmitting,
    setPlace,
    handleInputChange,
    handleSubmit
  } = useAddActivity(tripId, parentFolderId, handleClose);

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validated) {
      handleSubmit(e);
    }
  };

  React.useEffect(() => {
    if (place) {
      setPlace({ id: place.placesId, ...place });
    }
  }, [setPlace, handleInputChange, parentFolderId, place]);

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title='Add Activity'
    >
      <Form onSubmit={handleFormSubmit}>
        <ActivityAutocomplete
          label='Title'
          placeholder='Enter title'
          setPlace={setPlace}
          bias={bias}
          place={place}
        />
        <ThInputText
          label='Website Link'
          placeholder='Enter here'
          value={activity.websiteUrl ?? ''}
          onChange={(value) => handleInputChange('websiteUrl', value)}
        />
        {/* <Form.Group className='mb-3 d-grid gap-2'>
          <Form.Label>Change Image</Form.Label>
          <Button
            id='imageButton'
            variant='outline-light'
            style={{
              backgroundImage: `url(${imageUrl ?? ''})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              padding: 0,
              border: 'solid',
              height: 'auto',
              minHeight: '160px'
            }}
          >
            {(!imageUrl || imageUrl === '') && (
              <div className='image-upload-empty d-flex flex-column justify-content-end align-items-center'>
                <SvgIcon type='img-default' />
              </div>
            )}
          </Button>
        </Form.Group> */}
        <Button
          className='mx-auto'
          style={{ marginTop: '24px' }}
          px={50}
          variant='primary'
          type='submit'
          disabled={!validated || isSubmitting}
        >
          {isSubmitting ? 'Adding...' : 'Add Activity'}
        </Button>
      </Form>
    </ModalCustom>
  );
};

export default AddActivityModal;
